module.exports = __webpack_public_path__ + "img/status-failed.fd1e166a.svg";